import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormsModule} from "@angular/forms";
import {ThemeService} from '../../../services/theme.service';
import {NgIf} from '@angular/common';

@Component({
  selector: 'app-switch',
  standalone: true,
  imports: [
    FormsModule,
    NgIf
  ],
  templateUrl: './switch.component.html',
  styleUrl: './switch.component.scss'
})
export class SwitchComponent {
  constructor(public themeService: ThemeService) {}

  @Input() value: boolean = false;
  @Input() type: 'classic' | 'new' = 'classic';
  @Output() emitValue: EventEmitter<boolean> = new EventEmitter();

  flag: boolean = false;


  switchFlag() {
    this.value = !this.value;
    this.emitValue.emit(this.value);
  }

}
